/* eslint-disable camelcase */
import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import {
  Switch,
  FormControl,
  TextField,
  CircularProgress,
  Button,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Typography,
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Tooltip from '@material-ui/core/Tooltip'
import FlashOnIcon from '@material-ui/icons/FlashOn'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import LinkIcon from '@material-ui/icons/Link'
import PublishOutlinedIcon from '@material-ui/icons/PublishOutlined'
import WarningIcon from '@material-ui/icons/Warning'

import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta'
import { ApiHelper } from '../../../common/helpers/ApiHelper'
import { Helper } from '../../../common/helpers/Helper'
import { UiHelper } from '../../../common/helpers/UiHelper'
import { AppConfig } from '../../../AppConfig'
import { AppStyles, AppTheme } from '../../../styles/AppTheme'
import { CommonTheme } from '../../../styles/Styles'
import { Controller } from '../../../common/Controller'
import { AppHelper } from '../../../helpers/AppHelper'
import { CdpHelper } from '../../../helpers/CdpHelper'
import { SearchBar } from '../../../common/components/SearchBar'
import {
  hasConfiguredActions,
  getActionChips,
  getSubOrgOptions,
  renderEnabledForBadges,
  getWorkflowFormDefinition,
  sanitizeWorkflowTitle,
  isValidWorkflowTitle,
  isValidWorkflowKey,
  tenantHasWorkflowTeams,
  ALL_SUBORGS_KEY,
  ALL_ORGS_KEY,
  getDefaultEnabledSubOrgIds,
  sanitizeEnabledSubOrgIdsForOrg,
  getLegacyStatusMeta,
  renderLegacyContextBadges,
  buildWorkflowPayloadFromLegacy,
  filterLegacyWorkflows,
  isMigratableLegacyWorkflow,
  sanitizeLegacyMigrationData,
  hasPendingOrDisabledLegacyWorkflows,
  sortWorkflowsForAdminList,
  prepareWorkflowsForOrderUi,
  getWorkflowReorderId,
  getTagKeysFromFieldDef,
  applyStatusOptionField,
  stripStatusOptionFields,
} from './WorkflowHelper'
import { WorkflowCreateDialog } from './WorkflowCreateDialog'
import { LeadFunnelDialog } from './LeadFunnelDialog'
import { WorkflowWhatsAppDialog } from './WorkflowWhatsAppDialog'

const STATUS_FILTER_ALL = { key: 'ALL', label: 'All' }
const STATUS_OPTIONS = [
  STATUS_FILTER_ALL,
  { key: 'LIVE', label: 'LIVE' },
  { key: 'DISABLED', label: 'DISABLED' },
]

const LEGACY_FILTER_UNMAPPED = { key: 'UNMAPPED', label: 'Pending Unmapped' }
const LEGACY_FILTER_ALL = { key: 'ALL', label: 'All Active Legacy' }
const LEGACY_FILTER_MAPPED = { key: 'MAPPED', label: 'Already Mapped' }
const LEGACY_FILTER_RECIPE = { key: 'RECIPE_READY', label: 'Recipe Available' }

const LEGACY_FILTER_OPTIONS = [
  LEGACY_FILTER_UNMAPPED,
  LEGACY_FILTER_ALL,
  LEGACY_FILTER_MAPPED,
  LEGACY_FILTER_RECIPE,
]

const GENERAL_SETTINGS_KEYS = [
  'OPTIONS_ATC',
  'OPTIONS_UNQUALIFICATION',
  'OPTIONS_LOST',
  'OPTIONS_BADTIMING',
]

function parseSettingCheckBoxValue(csvValue) {
  if (csvValue == null || csvValue === '') {
    return []
  }
  return String(csvValue)
    .split(',')
    .map((token) => token.trim())
    .filter(Boolean)
}

function serializeSettingCheckBoxValue(keys) {
  if (!Array.isArray(keys)) {
    return ''
  }
  return keys
    .map((item) => {
      if (item && typeof item === 'object' && item.key != null) {
        return String(item.key).trim()
      }
      return String(item).trim()
    })
    .filter(Boolean)
    .join(',')
}

export class Workflows extends BaseEntityPageSlixta {
  constructor(props) {
    super(props)

    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageTitle = Helper.getString('workflows', 'Workflows')
    this.pageKey = 'workflows'

    this.orgId = (props.match && props.match.params && props.match.params.orgId) ||
      AppHelper.parseOrgId(window.location.pathname) ||
      (Controller.get().roleHelper() && Controller.get().roleHelper().getOrgId()) ||
      'PRODUCT'

    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: this.pageTitle },
    ]

    this.toFetch = [
      {
        key: 'workflows',
        ms: this.ms,
        method: 'GET',
        paths: ['workflows'],
        queryParams: { orgId: this.orgId, pb: 'fieldDef' },
      },
    ]

    this.apiData = {
      orgId: this.orgId,
    }

    this.emptyText = 'No workflows found.'

    this.state = {
      ...this.state,
      masterWorkflowsList: [],
      searchText: '',
      statusFilterSelected: STATUS_FILTER_ALL,

      // Legacy migration state
      legacyMigration: null,
      activeTab: 'WORKFLOWS',
      legacyFilterSelected: LEGACY_FILTER_UNMAPPED,
      legacySearchText: '',
      migratingKeys: {},
      recipesCatalog: [],

      // Modals
      createDialogOpen: false,
      configureWaDialogOpen: false,
      workflowToConfigureWa: null,
      leadFunnelDialogOpen: false,

      // Status toggling tracking
      togglingIds: {},
      availableTags: [],

      orderUIMode: this.canReorderWorkflows()
        ? ApiHelper.ORDER_UI_MODE.INTERACTIVE
        : ApiHelper.ORDER_UI_MODE.STATIC,
    }

    this.tableHeadersMap = this.buildTableHeadersMap()
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.cellWidths = this.buildCellWidths()

    this.headerActions = [
      {
        label: 'Create',
        onClick: () => this.handleCreateDirect(),
      },
      {
        label: 'Pick a recipe',
        onClick: () => this.openCreateDialog(),
      },
      {
        label: 'Funnel',
        tooltip: 'Funnel',
        icon: 'filter_alt',
        type: 'icon-label',
        onClick: () => this.openLeadFunnelDialog(),
      },
      {
        label: 'Settings',
        tooltip: 'Settings',
        icon: 'settings',
        type: 'icon-label',
        onClick: () => this.openGeneralSettingsDialog(),
      },
      {
        label: 'Refresh',
        tooltip: 'Refresh',
        icon: 'refresh',
        type: 'icon-label',
        onClick: () => this.fetchItems(),
      },
    ]
  }

  hasTeamsColumn() {
    return tenantHasWorkflowTeams(this.fieldDef, this.subOrgs)
  }

  buildTableHeadersMap() {
    const showEnabledFor = this.hasTeamsColumn()
    return {
      ...(this.canReorderWorkflows() ? {
        Order: (current) => {
          if (current && current._isMappedToLegacy) {
            return (
              <Tooltip title='Mapped to legacy workflow' placement='top'>
                <LinkIcon className={css(Styles.mappedIcon)} />
              </Tooltip>
            )
          }
          return current.order
        },
      } : {}),
      Name: (current) => {
        const workflowKey = current.workflowKey || ''
        return (
          <div className={css(Styles.titleContainer)}>
            <span className={css(Styles.line1)}>{current.title}</span>
            {workflowKey && (
              <div className={css(Styles.workflowKeyRow)}>
                <span className={css(Styles.line3)}>{workflowKey}</span>
              </div>
            )}
          </div>
        )
      },
      ...(showEnabledFor ? {
        'Enabled For': (current) => {
          const subOrgOptions = getSubOrgOptions(this.fieldDef)
          return renderEnabledForBadges(current.enabledSubOrgIds, subOrgOptions)
        },
      } : {}),
      'Actions Configured': (current) => {
        const chips = getActionChips(current)
        if (!chips || chips.length === 0) {
          return (
            <span className={css(Styles.noActions)}>No actions configured</span>
          )
        }
        return (
          <div className={css(Styles.chipsWrapper)}>
            {chips.map((chip) => {
              const chipEl = (
                <span
                  className={css(
                    Styles.actionChip,
                    chip.color === 'primary' && Styles.actionChipPrimary,
                    chip.broken && Styles.actionChipWarning
                  )}
                >
                  {chip.broken && (
                    <WarningIcon className={css(Styles.actionChipWarningIcon)} />
                  )}
                  {chip.icon === 'whatsapp' && (
                    <WhatsAppIcon className={css(Styles.actionChipWaIcon)} />
                  )}
                  {chip.label}
                </span>
              )
              if (chip.broken && chip.tooltip) {
                return (
                  <Tooltip key={chip.key} title={chip.tooltip} placement='top'>
                    <span className={css(Styles.actionChipTooltipWrap)}>{chipEl}</span>
                  </Tooltip>
                )
              }
              return <React.Fragment key={chip.key}>{chipEl}</React.Fragment>
            })}
          </div>
        )
      },
      Status: (current) => {
        const isLive = current.state === 'LIVE'
        const isToggling = Boolean(this.state.togglingIds && this.state.togglingIds[current.id])
        return (
          <div className={css(Styles.statusCell)} onClick={(e) => e.stopPropagation()}>
            {isToggling ? (
              <CircularProgress size={20} style={{ margin: '0 8px' }} />
            ) : (
              <Switch
                checked={isLive}
                onChange={(e) => this.handleStatusToggle(current, e.target.checked)}
                color='primary'
                size='small'
              />
            )}
          </div>
        )
      },
    }
  }

  buildCellWidths() {
    const showEnabledFor = this.hasTeamsColumn()
    return {
      ...(this.canReorderWorkflows() ? { Order: Styles.cellOrder } : {}),
      Name: Styles.cellName,
      ...(showEnabledFor ? { 'Enabled For': Styles.cellEnabledFor } : {}),
      'Actions Configured': Styles.cellActions,
      Status: Styles.cellStatus,
    }
  }

  canReorderWorkflows() {
    const userMgr = Controller.get().userMgr && Controller.get().userMgr()
    const roleHelper = Controller.get().roleHelper && Controller.get().roleHelper()
    return Boolean(
      (userMgr && userMgr.isProductSU && userMgr.isProductSU())
      || (roleHelper && roleHelper.hasCurrentOrgRole && roleHelper.hasCurrentOrgRole('SUPERUSER'))
    )
  }

  filterWorkflows(masterList, searchText, statusFilter) {
    let list = masterList || []
    if (statusFilter && statusFilter !== 'ALL') {
      list = list.filter((wf) => wf && wf.state === statusFilter)
    }
    if (searchText && searchText.trim()) {
      const q = searchText.trim().toLowerCase()
      list = list.filter((wf) => {
        const titleMatch = String(wf.title || '').toLowerCase().includes(q)
        const keyMatch = String(wf.workflowKey || '').toLowerCase().includes(q)
        return titleMatch || keyMatch
      })
    }
    return list
  }

  async onFetchSuccess(results) {
    const workflowsResult = this.getResult(results, 'workflows')
    const rawItems = (workflowsResult && Array.isArray(workflowsResult.items))
      ? workflowsResult.items
      : (Array.isArray(workflowsResult) ? workflowsResult : [])

    if (workflowsResult && workflowsResult.fieldDef) {
      this.fieldDef = workflowsResult.fieldDef
      this.formDefinition = workflowsResult.fieldDef
      this.tableHeadersMap = this.buildTableHeadersMap()
      this.tableHeaders = Object.keys(this.tableHeadersMap)
      this.cellWidths = this.buildCellWidths()
    }
    this.templateVariables = (workflowsResult && workflowsResult.templateVariables) || []

    const rawLegacyMigration = (workflowsResult && workflowsResult.legacyMigration) || this.state.legacyMigration || null
    const legacyMigration = sanitizeLegacyMigrationData(rawLegacyMigration)
    const legacyList = (legacyMigration && legacyMigration.allLegacyActiveWorkflows) || []

    const sortedItems = sortWorkflowsForAdminList(rawItems, legacyList)
    const canReorder = this.canReorderWorkflows()
    this.masterWorkflowsList = canReorder
      ? prepareWorkflowsForOrderUi(sortedItems, legacyList)
      : sortedItems

    let availableTags = this.state.availableTags || []
    if (availableTags.length === 0) {
      const fromFieldDef = getTagKeysFromFieldDef(workflowsResult && workflowsResult.fieldDef)
      if (fromFieldDef.length > 0) {
        availableTags = fromFieldDef
      } else {
        try {
          const attribsGroupId = `settingscrmcontactattrs${this.orgId}`
          const attrsRes = await ApiHelper.callAwait({
            ms: AppConfig.CDP_MS.ENDPOINT,
            method: 'GET',
            paths: ['items', `${attribsGroupId}-all`],
            queryParams: { orgId: this.orgId, groupId: attribsGroupId },
          })
          const extracted = Helper.extractAttrs(attrsRes, 'tags')
          if (Array.isArray(extracted)) {
            availableTags = extracted
          }
        } catch (tagErr) {
          // Non-critical
        }
      }
    }

    if (workflowsResult && workflowsResult.nextPage) {
      this.handleNextpage(workflowsResult)
    }

    const statusKey = (this.state.statusFilterSelected && this.state.statusFilterSelected.key) || 'ALL'
    const filteredItems = this.filterWorkflows(
      this.masterWorkflowsList,
      this.state.searchText,
      statusKey
    )

    const showLegacyTab = hasPendingOrDisabledLegacyWorkflows(legacyMigration)

    const nextActiveTab = (!showLegacyTab && this.state.activeTab === 'UNMAPPED')
      ? 'WORKFLOWS'
      : this.state.activeTab

    this.setState({
      items: filteredItems,
      legacyMigration,
      availableTags,
      activeTab: nextActiveTab,
      orderUIMode: canReorder
        ? ApiHelper.ORDER_UI_MODE.INTERACTIVE
        : ApiHelper.ORDER_UI_MODE.STATIC,
    })
  }

  onOrderEdit = async (orderEditData) => {
    if (!this.canReorderWorkflows()) return
    const { current, otherItem } = orderEditData || {}
    if (!current || !otherItem) return
    // MAPPED (legacy-backed) rows are not reorderable; BE ignores their order.
    if (current._isMappedToLegacy || otherItem._isMappedToLegacy) return

    const master = [...(this.masterWorkflowsList || [])]
    const currentId = getWorkflowReorderId(current)
    const otherId = getWorkflowReorderId(otherItem)
    const i = master.findIndex((w) => getWorkflowReorderId(w) === currentId)
    const j = master.findIndex((w) => getWorkflowReorderId(w) === otherId)
    if (i < 0 || j < 0 || i === j) return

    const swapped = [...master]
    swapped[i] = master[j]
    swapped[j] = master[i]

    const orderedIds = swapped.map(getWorkflowReorderId).filter(Boolean)
    if (orderedIds.length !== swapped.length) {
      this.showToast('Unable to reorder: missing workflow id', 'error')
      return
    }

    this.setState({
      fetchState: ApiHelper.State.LOADING,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
    })

    try {
      const res = await CdpHelper.reorderWorkflows(this.orgId, orderedIds)
      if (!res || res.status !== 'OK') {
        throw new Error((res && (res.message || res.error)) || 'Failed to reorder workflows')
      }

      const legacyList = (this.state.legacyMigration && this.state.legacyMigration.allLegacyActiveWorkflows) || []
      const withOrders = prepareWorkflowsForOrderUi(swapped, legacyList)
      this.masterWorkflowsList = withOrders
      const statusKey = (this.state.statusFilterSelected && this.state.statusFilterSelected.key) || 'ALL'
      const items = this.filterWorkflows(withOrders, this.state.searchText, statusKey)

      this.setState({
        items,
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
        isOrderChanged: true,
        currentOrderChangeIndex: null,
        orderChangeEvent: null,
      })
    } catch (err) {
      this.setState({
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
        currentOrderChangeIndex: null,
        orderChangeEvent: null,
        isOrderChanged: false,
      })
      this.showToast(Helper.getErrorMsg(err) || 'Failed to reorder workflows', 'error')
    }
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) { return '' }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions = (current) => {
    const actions = []
    actions.push(UiHelper.buttonEdit(this, current))
    return actions
  }

  onMenuItems = (current) => {
    const actions = []
    const menuItems = [
      {
        current,
        key: `${current.id}-configure-wa`,
        action: () => this.openConfigureWhatsAppDialog(current),
        title: 'Configure WhatsApp',
        icon: 'chat',
      },
      {
        current,
        key: `${current.id}-create-copy`,
        action: () => UiHelper.openModalForCreateCopy.call(this, current, 'WORKFLOW'),
        title: Helper.getString('createcopy', 'Create a copy'),
        icon: 'file_copy',
      },
      {
        current,
        key: `${current.id}-delete`,
        action: () => this.openModalForDelete(current),
        title: Helper.getString('delete', 'Delete'),
        icon: 'delete_outline',
      },
    ]
    menuItems.forEach((item) => {
      actions.push(UiHelper.actionButton(item))
    })
    return actions
  }

  onSearch = (searchText = '') => {
    const statusKey = (this.state.statusFilterSelected && this.state.statusFilterSelected.key) || 'ALL'
    const items = this.filterWorkflows(
      this.masterWorkflowsList,
      searchText,
      statusKey
    )
    this.setState({ searchText, items })
  }

  clearSearch = () => {
    const items = this.filterWorkflows(
      this.masterWorkflowsList,
      '',
      STATUS_FILTER_ALL.key
    )
    this.setState({
      searchText: '',
      statusFilterSelected: STATUS_FILTER_ALL,
      items,
    })
  }

  onStatusFilterChange = (e, val) => {
    if (!val || !val.key) return
    const items = this.filterWorkflows(
      this.masterWorkflowsList,
      this.state.searchText,
      val.key
    )
    this.setState({
      statusFilterSelected: val,
      items,
    })
  }

  handleStatusToggle = async (workflow, nextChecked) => {
    const nextState = nextChecked ? 'LIVE' : 'DISABLED'

    if (nextState === 'LIVE' && !hasConfiguredActions(workflow)) {
      this.showToast('Cannot enable workflow without configured actions. Please configure at least one action first.', 'error')
      return
    }

    this.setState((prev) => ({
      togglingIds: { ...prev.togglingIds, [workflow.id]: true },
    }))

    try {
      await ApiHelper.callAwait({
        ms: this.ms,
        method: 'PUT',
        paths: ['workflows', workflow.id],
        queryParams: { orgId: this.orgId },
        jsonBody: { state: nextState },
      })

      const updateList = (list) =>
        list.map((item) => (item.id === workflow.id ? { ...item, state: nextState } : item))

      this.masterWorkflowsList = updateList(this.masterWorkflowsList)
      this.setState((prev) => ({
        items: updateList(prev.items),
        togglingIds: { ...prev.togglingIds, [workflow.id]: false },
      }))

      this.showToast(`Workflow "${workflow.title}" is now ${nextState}`, 'success')
    } catch (err) {
      const errMsg = Helper.getErrorMsg(err) || `Failed to update status for ${workflow.title}`
      this.setState((prev) => ({
        togglingIds: { ...prev.togglingIds, [workflow.id]: false },
      }))
      this.showToast(errMsg, 'error')
    }
  }

  onAdd() {
    this.apiData = {
      orgId: this.orgId,
    }
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['workflows'], queryParams: { orgId: this.orgId } }),
    })
  }

  onEdit(current) {
    this.apiData = {
      orgId: this.orgId,
      id: current && current.id,
    }
    this.setState({
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['workflows', current && current.id], queryParams: { orgId: this.orgId } }),
    })
  }

  onDelete(current) {
    this.apiData = {
      orgId: this.orgId,
      id: current && current.id,
    }
    this.setState({
      apiMethod: 'DELETE',
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['workflows', current && current.id], queryParams: { orgId: this.orgId } }),
    })
  }

  openModalForEdit = (current, customFormDef) => {
    if (!current) return
    // Hide auto-managed OPTIONS_* from dialog values; re-applied on submit
    const formValues = {
      ...current,
      fieldsToUpdate: stripStatusOptionFields(current.fieldsToUpdate),
    }
    const formDef = customFormDef || getWorkflowFormDefinition({
      fieldDef: this.fieldDef,
      availableTags: this.state.availableTags,
      mode: 'edit',
      orgId: this.orgId,
      prefill: formValues,
      subOrgs: this.subOrgs,
    })
    this.editingWorkflow = current
    super.openModalForEdit(formValues, formDef)
  }

  openWorkflowEdit = (current) => {
    this.openModalForEdit(current)
  }

  openModalForDelete = (current, customFormDef) => {
    if (!current) return
    const deleteFormDef = customFormDef || {
      steps: [
        {
          title: 'Workflow',
          fields: [
            {
              key: 'title',
              label: 'Workflow Title',
              type: 'edit_text',
              value: current.title || '',
              disabled: true,
            },
          ],
        },
      ],
      title: 'Delete Workflow',
      formType: 'delete',
      ctaButtonText: 'Delete',
    }
    super.openModalForDelete(current, deleteFormDef)
  }

  handleCreateDirect = () => {
    const subOrgOptions = getSubOrgOptions(this.fieldDef)
    const defaultEnabledSubOrgIds = getDefaultEnabledSubOrgIds(subOrgOptions, this.orgId)

    const formDef = getWorkflowFormDefinition({
      fieldDef: this.fieldDef,
      availableTags: this.state.availableTags,
      mode: 'add',
      orgId: this.orgId,
      prefill: {
        enabledSubOrgIds: defaultEnabledSubOrgIds,
      },
      subOrgs: this.subOrgs,
    })
    this.openModalForAdd(formDef, false)
  }

  openConfigureWhatsAppDialog = (workflow) => {
    this.setState({
      configureWaDialogOpen: true,
      workflowToConfigureWa: workflow,
    })
  }

  closeConfigureWhatsAppDialog = () => {
    this.setState({
      configureWaDialogOpen: false,
      workflowToConfigureWa: null,
    })
  }

  handleWhatsAppSaved = (updated, options = {}) => {
    if (options && options.keepOpen) {
      if (updated && this.state.workflowToConfigureWa) {
        this.setState({
          workflowToConfigureWa: {
            ...this.state.workflowToConfigureWa,
            ...updated,
          },
        })
      }
      this.fetchItems()
      return
    }
    this.closeConfigureWhatsAppDialog()
    this.fetchItems()
  }

  openCreateDialog = () => {
    this.setState({ createDialogOpen: true })
  }

  closeCreateDialog = () => {
    this.setState({ createDialogOpen: false })
  }

  openLeadFunnelDialog = () => {
    this.setState({ leadFunnelDialogOpen: true })
  }

  closeLeadFunnelDialog = () => {
    this.setState({ leadFunnelDialogOpen: false })
  }

  openGeneralSettingsDialog = () => {
    this.editingWorkflow = null
    const formValues = {}
    const fields = []

    GENERAL_SETTINGS_KEYS.forEach((key) => {
      const settingDef = CdpHelper.getSettingDef(this.orgId, key)
      if (!settingDef) return

      const fieldTemplate = (settingDef.fields && settingDef.fields[0]) || {}
      const field = {
        ...fieldTemplate,
        key,
        label: settingDef.title || key,
        placement: 'left',
        fullWidth: true,
        addOptions: true,
        addOptionsFormatter: 'tagformat',
        options: (fieldTemplate.options || []).map((o) => ({ ...o })),
      }

      const rawValue = AppHelper.getSetting(this.orgId, key)
        || settingDef.defaultValue
        || ''
      const selected = parseSettingCheckBoxValue(rawValue)
      selected.forEach((optionKey) => {
        if (!field.options.some((o) => o && o.key === optionKey)) {
          field.options.push({ key: optionKey, label: optionKey })
        }
      })

      formValues[key] = selected
      fields.push(field)
    })

    if (fields.length === 0) {
      this.showToast('Settings are not available.', 'error')
      return
    }

    const formDef = {
      title: 'Settings',
      formType: 'edit',
      ctaButtonText: 'Save',
      maxWidth: 'md',
      _subType: 'general-settings',
      steps: [{ fields }],
    }
    super.openModalForEdit(formValues, formDef)
  }

  onFormFieldOptionAdd = async ({ formField, value }) => {
    if (!formField) return []
    if (!formField.options) formField.options = []
    const trimmed = String(value || '').trim()
    if (!trimmed) return formField.options
    if (!formField.options.some((o) => o && (o.key === trimmed || o.label === trimmed))) {
      formField.options.push({ key: trimmed, label: trimmed, text: trimmed })
    }
    return formField.options
  }

  submitGeneralSettings = async (options, done) => {
    const { formData, caller } = options
    try {
      for (const key of GENERAL_SETTINGS_KEYS) {
        const prevStored = CdpHelper.getSetting(key, this.orgId)
        const previousValue = prevStored != null ? String(prevStored) : ''
        const newValue = serializeSettingCheckBoxValue(formData && formData[key])
        if (newValue === previousValue.trim()) continue

        const res = await CdpHelper.setSetting({
          orgId: this.orgId,
          settingsKey: key,
          settingsValue: newValue,
          previousKey: key,
          previousValue,
        })
        if (!res || !res.success) {
          throw new Error((res && res.error) || `Failed to update ${key}`)
        }
      }

      this.setState({ modalOpen: false })
      this.showToast('Settings updated successfully', 'success')
      if (caller) {
        caller.setState({ inProcess: false, success: true })
      }
      if (done) done()
    } catch (err) {
      const errMsg = Helper.getErrorMsg(err)
      if (caller) {
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg,
          success: false,
          message: errMsg,
          inProcess: false,
        })
      }
      this.showToast(errMsg || 'Failed to update settings', 'error')
    }
  }

  handleRecipeSelect = (selection) => {
    this.closeCreateDialog()

    if (selection && selection.recipe) {
      const recipe = selection.recipe
      const subOrgOptions = getSubOrgOptions(this.fieldDef)
      const defaultEnabledSubOrgIds = getDefaultEnabledSubOrgIds(subOrgOptions, this.orgId)

      const formDef = getWorkflowFormDefinition({
        fieldDef: this.fieldDef,
        availableTags: this.state.availableTags,
        mode: 'add',
        orgId: this.orgId,
        prefill: {
          title: sanitizeWorkflowTitle(recipe.title || ''),
          nextLeadStatus: recipe.nextLeadStatus || '',
          tagsToAdd: recipe.tagsToAdd || [],
          tagsToRemove: recipe.tagsToRemove || [],
          fieldsToUpdate: recipe.fieldsToUpdate || [],
          fieldsToClear: recipe.fieldsToClear || [],
          captureNote: recipe.captureNote === 'ENABLED' ? 'ENABLED' : 'DISABLED',
          paymentTransaction: recipe.paymentTransaction === 'ENABLED' ? 'ENABLED' : 'DISABLED',
          enabledSubOrgIds: defaultEnabledSubOrgIds,
        },
        subOrgs: this.subOrgs,
      })
      this.openModalForAdd(formDef, false)
    }
  }

  customSubmit(options, done) {
    const { formType, formData, caller } = options

    if (this.formDefinition && this.formDefinition._subType === 'general-settings') {
      return this.submitGeneralSettings(options, done)
    }

    // Handle delete mode - let caller submit standard DELETE request
    if (formType === 'delete' || formType === 'del') {
      return caller.submit.call(caller, formData, true)
    }

    // Handle standard create-copy mode
    if (this.formDefinition && this.formDefinition._subType === 'create-copy') {
      const rawTitle = (formData && formData.title) || ''
      const sanitizedTitle = sanitizeWorkflowTitle(rawTitle)

      if (!sanitizedTitle) {
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: 'Workflow Title is required.',
          inProcess: false,
        })
        return
      }

      if (!isValidWorkflowTitle(sanitizedTitle)) {
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: 'Title must contain only uppercase letters, digits, spaces, parentheses, and underscores.',
          inProcess: false,
        })
        return
      }

      formData.title = sanitizedTitle
      formData.workflowKey = ''
      formData.fieldsToUpdate = applyStatusOptionField(
        formData.fieldsToUpdate,
        formData.nextLeadStatus
      )
      if (!formData.fieldsToUpdate || formData.fieldsToUpdate.length === 0) {
        delete formData.fieldsToUpdate
      }
      return caller.submit.call(caller, formData, true)
    }

    // Standard add / edit workflow submission
    const rawTitle = (formData && formData.title) || ''
    const sanitizedTitle = sanitizeWorkflowTitle(rawTitle)

    if (!sanitizedTitle) {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: 'Workflow Title is required.',
        inProcess: false,
      })
      return
    }

    if (!isValidWorkflowTitle(sanitizedTitle)) {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: 'Title must contain only uppercase letters, digits, spaces, parentheses, and underscores.',
        inProcess: false,
      })
      return
    }

    const nextLeadStatus = (formData && formData.nextLeadStatus) || ''

    const workflowKey = ((formData && formData.workflowKey) || '').trim()
    if (workflowKey && !isValidWorkflowKey(workflowKey)) {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: 'Workflow Key must start with a letter and contain only letters, numbers, or underscores.',
        inProcess: false,
      })
      return
    }

    // Status is not editable in add/edit workflow - preserve existing or default to DISABLED
    const state = (formData && formData.state) || (this.editingWorkflow && this.editingWorkflow.state) || 'DISABLED'
    if (state === 'LIVE' && !hasConfiguredActions(formData)) {
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: 'Cannot enable workflow without configured actions. Please configure at least one action first.',
        inProcess: false,
      })
      return
    }

    // Handle ALL_SUBORGS / main org for enabledSubOrgIds; drop foreign org/team ids
    const subOrgOptions = getSubOrgOptions(this.fieldDef)
    const enabledSubOrgIds = sanitizeEnabledSubOrgIdsForOrg(
      formData && formData.enabledSubOrgIds,
      subOrgOptions,
      this.orgId
    )

    const payload = {
      ...formData,
      title: sanitizedTitle,
      nextLeadStatus,
      state,
      enabledSubOrgIds,
      fieldsToUpdate: applyStatusOptionField(
        formData && formData.fieldsToUpdate,
        nextLeadStatus
      ),
    }

    if (workflowKey) {
      payload.workflowKey = workflowKey
    } else {
      delete payload.workflowKey
    }

    if (!payload.waTemplateKey) delete payload.waTemplateKey
    if (!payload.nextLeadStatus || payload.nextLeadStatus === 'NONE') delete payload.nextLeadStatus
    if (!payload.fieldsToUpdate || payload.fieldsToUpdate.length === 0) delete payload.fieldsToUpdate

    return caller.submit.call(caller, payload, true)
  }

  onCompleteAction = (options) => {
    const isAdd = this.formDefinition && this.formDefinition.formType === 'add'
    const isDelete = this.formDefinition && (this.formDefinition.formType === 'delete' || this.formDefinition.formType === 'del')
    const isCopy = this.formDefinition && this.formDefinition._subType === 'create-copy'

    this.setState({ modalOpen: false })
    let msg = 'Workflow updated successfully'
    if (isDelete) {
      msg = 'Workflow deleted successfully'
    } else if (isCopy) {
      msg = 'Workflow copied successfully'
    } else if (isAdd) {
      msg = 'Workflow created successfully'
    }
    this.showToast(msg, 'success')

    const apiInvokeData = options && options.apiInvokeData
    const reqBody = (apiInvokeData && apiInvokeData.reqBody) || {}
    const resp = (apiInvokeData && apiInvokeData.responseBody) || {}
    const respItem = (resp && resp.item) || resp || {}
    const wfId = (this.editingWorkflow && this.editingWorkflow.id)
      || (this.apiData && this.apiData.id)
      || respItem.id
      || reqBody.id

    if (isDelete && wfId) {
      this.masterWorkflowsList = (this.masterWorkflowsList || []).filter(w => w.id !== wfId)
    } else if (wfId || isAdd) {
      const mergedWf = { ...this.editingWorkflow, ...reqBody, ...respItem, id: wfId }
      if (isAdd) {
        this.masterWorkflowsList = [mergedWf, ...(this.masterWorkflowsList || [])]
      } else {
        this.masterWorkflowsList = (this.masterWorkflowsList || []).map(w => w.id === wfId ? { ...w, ...mergedWf } : w)
      }
    }
    this.editingWorkflow = null

    this.fetchItems()
  }

  showToast = (message, severity = 'success') => {
    this.setState({
      showToast: true,
      toastMsg: message,
      isErrorToast: severity === 'error',
    })
  }

  handleTabChange = (nextTab) => {
    this.setState({ activeTab: nextTab })
  }

  onLegacySearch = (legacySearchText = '') => {
    this.setState({ legacySearchText })
  }

  clearLegacySearch = () => {
    this.setState({
      legacySearchText: '',
      legacyFilterSelected: LEGACY_FILTER_UNMAPPED,
    })
  }

  onLegacyFilterChange = (e, val) => {
    if (!val || !val.key) return
    this.setState({ legacyFilterSelected: val })
  }

  getLegacyWorkflowsToDisplay() {
    const { legacyMigration, legacyFilterSelected, legacySearchText } = this.state
    if (!legacyMigration) return []

    const filterKey = (legacyFilterSelected && legacyFilterSelected.key) || 'UNMAPPED'
    let sourceList = []

    if (filterKey === 'UNMAPPED') {
      sourceList = Array.isArray(legacyMigration.unmappedWorkflows)
        ? legacyMigration.unmappedWorkflows
        : []
    } else {
      sourceList = (Array.isArray(legacyMigration.allLegacyActiveWorkflows) && legacyMigration.allLegacyActiveWorkflows.length > 0)
        ? legacyMigration.allLegacyActiveWorkflows
        : (Array.isArray(legacyMigration.unmappedWorkflows) ? legacyMigration.unmappedWorkflows : [])
    }

    return filterLegacyWorkflows(sourceList, legacySearchText, filterKey)
  }

  fetchRecipesCatalog = async () => {
    if (this.state.recipesCatalog && this.state.recipesCatalog.length > 0) {
      return this.state.recipesCatalog
    }
    try {
      const res = await ApiHelper.callAwait({
        ms: AppConfig.CDP_MS.ENDPOINT,
        method: 'GET',
        paths: ['miscs', 'workflow-recipes'],
        queryParams: { orgId: this.orgId },
      })
      if (res && Array.isArray(res.recipes)) {
        this.setState({ recipesCatalog: res.recipes })
        return res.recipes
      }
    } catch (e) {
      // Graceful fallback
    }
    return []
  }

  updateLegacyItemLocally = (key, updates) => {
    const { legacyMigration } = this.state
    if (!legacyMigration) return

    const updateItem = (item) => (item.key === key ? { ...item, ...updates } : item)

    const updatedAll = (legacyMigration.allLegacyActiveWorkflows || []).map(updateItem)
    const isNowMapped = updates.status === 'MAPPED'
    const updatedUnmapped = isNowMapped
      ? (legacyMigration.unmappedWorkflows || []).filter(item => item.key !== key)
      : (legacyMigration.unmappedWorkflows || []).map(updateItem)

    const unmappedCount = updatedAll.filter(item => item.status === 'UNMAPPED').length
    const mappedCount = updatedAll.filter(item => item.status === 'MAPPED').length

    const updatedMigration = {
      ...legacyMigration,
      unmappedCount,
      mappedCount,
      hasUnmappedLegacyWorkflows: unmappedCount > 0,
      unmappedWorkflows: updatedUnmapped,
      allLegacyActiveWorkflows: updatedAll,
    }

    this.setState({ legacyMigration: updatedMigration })
  }

  handleMigrateLegacyWorkflow = async (item) => {
    if (!item || !item.key) return
    if (this.state.migratingKeys && this.state.migratingKeys[item.key]) return

    this.setState((prev) => ({
      migratingKeys: { ...prev.migratingKeys, [item.key]: true },
    }))

    try {
      const recipes = await this.fetchRecipesCatalog()
      const matchingRecipe = (Array.isArray(recipes) && item.suggestedRecipeKey)
        ? recipes.find((r) => r.key === item.suggestedRecipeKey)
        : null

      const payload = buildWorkflowPayloadFromLegacy({
        legacyItem: item,
        recipe: matchingRecipe,
        fieldDef: this.fieldDef,
        orgId: this.orgId,
      })

      const created = await ApiHelper.callAwait({
        ms: this.ms,
        method: 'POST',
        paths: ['workflows'],
        queryParams: { orgId: this.orgId },
        jsonBody: payload,
      })

      this.showToast(`Workflow "${payload.title}" migrated successfully!`, 'success')

      const mappedId = created && (created.id || (created.item && created.item.id))
      const createdItem = {
        ...payload,
        id: mappedId || (created && created.id),
      }
      this.masterWorkflowsList = [createdItem, ...(this.masterWorkflowsList || [])]
      this.updateLegacyItemLocally(item.key, {
        status: 'MAPPED',
        mappedWorkflowId: mappedId || null,
        mappedWorkflowKey: payload.workflowKey || null,
      })

      this.fetchItems()
    } catch (err) {
      const errMsg = Helper.getErrorMsg(err) || `Failed to migrate workflow ${item.title || item.key}`
      this.showToast(errMsg, 'error')
    } finally {
      this.setState((prev) => ({
        migratingKeys: { ...prev.migratingKeys, [item.key]: false },
      }))
    }
  }

  openLegacyCustomize = async (item) => {
    if (!item) return
    if (item.key) {
      this.setState((prev) => ({
        migratingKeys: { ...prev.migratingKeys, [item.key]: true },
      }))
    }

    try {
      const recipes = await this.fetchRecipesCatalog()
      const matchingRecipe = (Array.isArray(recipes) && item.suggestedRecipeKey)
        ? recipes.find((r) => r.key === item.suggestedRecipeKey)
        : null

      const prefill = buildWorkflowPayloadFromLegacy({
        legacyItem: item,
        recipe: matchingRecipe,
        fieldDef: this.fieldDef,
        orgId: this.orgId,
      })

      const formDef = getWorkflowFormDefinition({
        fieldDef: this.fieldDef,
        availableTags: this.state.availableTags,
        mode: 'add',
        prefill,
        orgId: this.orgId,
      })

      this.openModalForAdd(formDef, false)
    } finally {
      if (item.key) {
        this.setState((prev) => ({
          migratingKeys: { ...prev.migratingKeys, [item.key]: false },
        }))
      }
    }
  }

  renderTabs() {
    const { activeTab, legacyMigration } = this.state
    if (!hasPendingOrDisabledLegacyWorkflows(legacyMigration)) {
      return null
    }

    const unmappedCount = (legacyMigration && legacyMigration.unmappedCount) || 0
    const totalDynamoCount = (this.masterWorkflowsList && this.masterWorkflowsList.length) || 0

    return (
      <div className={css(Styles.tabsContainer)}>
        <Tabs
          value={activeTab}
          onChange={(e, val) => this.handleTabChange(val)}
          indicatorColor='primary'
          textColor='primary'
        >
          <Tab
            value='WORKFLOWS'
            label={
              <span className={css(Styles.tabLabel)}>
                Workflows
                <span className={css(Styles.tabCountBadge)}>
                  {totalDynamoCount}
                </span>
              </span>
            }
            className={css(Styles.tabRoot)}
          />
          <Tab
            value='UNMAPPED'
            label={
              <span className={css(Styles.tabLabel)}>
                Legacy Workflows
                {unmappedCount > 0 ? (
                  <span className={css(Styles.tabCountBadgeWarning)}>
                    {unmappedCount}
                  </span>
                ) : (
                  <span className={css(Styles.tabCountBadge)}>
                    0
                  </span>
                )}
              </span>
            }
            className={css(Styles.tabRoot)}
          />
        </Tabs>
      </div>
    )
  }

  renderWorkflowsToolbar() {
    const statusValue = this.state.statusFilterSelected || STATUS_FILTER_ALL
    const multiStatus = STATUS_OPTIONS.length > 1

    return (
      <div className={css(Styles.toolbar)}>
        <div className={css(Styles.formControlContainer)}>
          <p className={css(Styles.label)}>Status</p>
          <FormControl className={css(Styles.formControlMainFilters)} variant='outlined'>
            <Autocomplete
              value={statusValue}
              options={STATUS_OPTIONS}
              onChange={(e, val) => this.onStatusFilterChange(e, val)}
              getOptionLabel={option => option.label || option.key || ''}
              getOptionSelected={(option, v) => option.key === v.key}
              disableClearable
              forcePopupIcon={multiStatus}
              popupIcon={multiStatus ? undefined : null}
              open={multiStatus ? undefined : false}
              renderInput={params => (
                <TextField
                  {...params}
                  variant='standard'
                  className={css(Styles.formControlFilters)}
                  InputProps={{
                    ...params.InputProps,
                    disableUnderline: true,
                    readOnly: true,
                    classes: {
                      root: css([Styles.textInputStyles, Styles.autoCompleteInputRoot]),
                      input: css(Styles.formInputStyle, Styles.textInput),
                    },
                  }}
                />
              )}
            />
          </FormControl>
        </div>
        <div className={css(Styles.searchBarContainer)} onSubmit={e => e.preventDefault()}>
          <SearchBar
            hint='Search by title or workflow key...'
            onSearch={this.onSearch}
            onClearSearch={this.clearSearch}
            searchText={this.state.searchText}
            searchButtonLabel='Filter'
            clearSearchLabel='Clear'
            autoRefresh
            debounceDuration={1}
            autoFocus={false}
            hideFiltersContainer
          />
        </div>
      </div>
    )
  }

  renderLegacyToolbar() {
    const { legacySearchText } = this.state

    return (
      <div className={css(Styles.toolbar)}>
        <div className={css(Styles.searchBarContainer)} onSubmit={e => e.preventDefault()}>
          <SearchBar
            hint='Search legacy workflows by title, key, or recipe...'
            onSearch={this.onLegacySearch}
            onClearSearch={this.clearLegacySearch}
            searchText={legacySearchText}
            searchButtonLabel='Filter'
            clearSearchLabel='Clear'
            autoRefresh
            debounceDuration={1}
            autoFocus={false}
            hideFiltersContainer
          />
        </div>
      </div>
    )
  }

  renderLegacyTable() {
    const displayedItems = this.getLegacyWorkflowsToDisplay()
    const { migratingKeys } = this.state
    const subOrgOptions = getSubOrgOptions(this.fieldDef)

    if (displayedItems.length === 0) {
      return (
        <Paper elevation={0} className={css(Styles.emptyLegacyContainer)}>
          <CheckCircleOutlineIcon style={{ fontSize: 48, color: '#10B981', marginBottom: 12 }} />
          <Typography variant='h6' style={{ fontWeight: 600, color: '#1F2937' }}>
            No Legacy Workflows
          </Typography>
          <Typography variant='body2' color='textSecondary' style={{ marginTop: 4 }}>
            All legacy workflows have been migrated and activated.
          </Typography>
        </Paper>
      )
    }

    return (
      <TableContainer component={Paper} elevation={0} className={css(Styles.legacyTableContainer)}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={css(Styles.legacyTableCellHead, Styles.cellLegacyName)}>Workflow</TableCell>
              <TableCell className={css(Styles.legacyTableCellHead, Styles.cellLegacyRecipe)}>Recipe & Details</TableCell>
              <TableCell className={css(Styles.legacyTableCellHead, Styles.cellLegacyTeams)}>Enabled For</TableCell>
              <TableCell className={css(Styles.legacyTableCellHead, Styles.cellLegacyStatus)}>Status</TableCell>
              <TableCell className={css(Styles.legacyTableCellHead, Styles.cellLegacyActions)}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((item) => {
              const isMigrating = Boolean(migratingKeys && migratingKeys[item.key])
              const statusMeta = getLegacyStatusMeta(item.status)
              const isUnmapped = item.status === 'UNMAPPED'

              return (
                <TableRow key={item.key} hover className={css(Styles.legacyTableRow)}>
                  {/* Column 1: Title, Key */}
                  <TableCell className={css(Styles.legacyTableCell)}>
                    <div className={css(Styles.legacyTitleWrapper)}>
                      <span className={css(Styles.line1)}>{item.title || item.key}</span>
                      <span className={css(Styles.line3)}>{item.key}</span>
                      {Array.isArray(item.entities) && item.entities.filter(ent => ent !== 'CRMCONTACT').length > 0 && (
                        <div className={css(Styles.chipsWrapper)} style={{ marginTop: 6 }}>
                          {item.entities.filter(ent => ent !== 'CRMCONTACT').map(ent => (
                            <Chip
                              key={ent}
                              size='small'
                              label={ent}
                              className={css(Styles.legacyEntityChip)}
                            />
                          ))}
                        </div>
                      )}
                    </div>
                  </TableCell>

                  {/* Column 2: Recipe & Actions (WhatsApp, Trigger) */}
                  <TableCell className={css(Styles.legacyTableCell)}>
                    <div className={css(Styles.chipsWrapper)}>
                      {item.suggestedRecipeKey ? (
                        <Chip
                          size='small'
                          label={`Recipe: ${item.suggestedRecipeKey}`}
                          className={css(item.canCreateFromRecipe ? Styles.legacyRecipeChip : Styles.legacyCustomChip)}
                        />
                      ) : (
                        <Chip
                          size='small'
                          label='Custom Action'
                          className={css(Styles.legacyCustomChip)}
                        />
                      )}

                      {item.hasWaAction && (
                        <Chip
                          size='small'
                          icon={<WhatsAppIcon style={{ fontSize: 13, color: '#128C7E', marginLeft: 4 }} />}
                          label='WhatsApp Action'
                          className={css(Styles.legacyWaChip)}
                        />
                      )}
                    </div>
                  </TableCell>

                  {/* Column 3: Enabled For Contexts */}
                  <TableCell className={css(Styles.legacyTableCell)}>
                    {renderLegacyContextBadges(item.enabledContexts, subOrgOptions)}
                  </TableCell>

                  {/* Column 4: Status */}
                  <TableCell className={css(Styles.legacyTableCell)}>
                    <span
                      style={{
                        display: 'inline-block',
                        fontSize: 11,
                        fontWeight: 600,
                        padding: '2px 8px',
                        borderRadius: 10,
                        textTransform: 'uppercase',
                        backgroundColor: statusMeta.bg,
                        color: statusMeta.text,
                        border: `1px solid ${statusMeta.border}`,
                      }}
                    >
                      {statusMeta.label}
                    </span>
                  </TableCell>

                  {/* Column 5: Action (Migrate Button / View Migrated) */}
                  <TableCell className={css(Styles.legacyTableCell)}>
                    {isUnmapped ? (
                      <Tooltip title='Migrate workflow' placement='top'>
                        <span>
                          <IconButton
                            size='small'
                            disabled={isMigrating}
                            onClick={() => this.openLegacyCustomize(item)}
                            className={css(Styles.migrateIconButton)}
                            aria-label='Migrate workflow'
                          >
                            {isMigrating ? (
                              <CircularProgress size={16} color='inherit' />
                            ) : (
                              <PublishOutlinedIcon style={{ fontSize: 18 }} />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                    ) : (
                      <div className={css(Styles.mappedActionGroup)}>
                        {item.mappedWorkflowId ? (
                          <Button
                            variant='outlined'
                            size='small'
                            color='primary'
                            startIcon={<i className='material-icons-outlined' style={{ fontSize: 16 }}>edit</i>}
                            className={css(Styles.viewMigratedButton)}
                            onClick={() => {
                              const wf = (this.masterWorkflowsList || []).find(w => w.id === item.mappedWorkflowId) || { id: item.mappedWorkflowId, title: item.title, workflowKey: item.mappedWorkflowKey }
                              this.openModalForEdit(wf)
                            }}
                          >
                            Edit
                          </Button>
                        ) : (
                          <span className={css(Styles.mappedText)}>Migrated</span>
                        )}
                        {item.mappedWorkflowKey && (
                          <span className={css(Styles.line3)}>{item.mappedWorkflowKey}</span>
                        )}
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  renderTable() {
    const { legacyMigration, activeTab } = this.state
    const showLegacyTab = hasPendingOrDisabledLegacyWorkflows(legacyMigration)
    if (activeTab === 'UNMAPPED' && showLegacyTab) {
      return this.renderLegacyTable()
    }
    return super.renderTable()
  }

  renderAboveTable() {
    const { legacyMigration, activeTab } = this.state
    const showLegacyTab = hasPendingOrDisabledLegacyWorkflows(legacyMigration)
    const isLegacyActive = activeTab === 'UNMAPPED' && showLegacyTab

    return (
      <div style={{ width: '100%', marginBottom: 16 }}>
        {showLegacyTab && this.renderTabs()}
        {isLegacyActive
          ? this.renderLegacyToolbar()
          : this.renderWorkflowsToolbar()}
      </div>
    )
  }

  renderBelowTable() {
    const {
      createDialogOpen,
      configureWaDialogOpen,
      workflowToConfigureWa,
      leadFunnelDialogOpen,
    } = this.state

    return (
      <>
        {/* Pick from Recipe Dialog */}
        {createDialogOpen && (
          <WorkflowCreateDialog
            open={createDialogOpen}
            onClose={this.closeCreateDialog}
            orgId={this.orgId}
            onSelect={this.handleRecipeSelect}
            showToast={this.showToast}
          />
        )}

        {/* Configure WhatsApp Dialog */}
        {configureWaDialogOpen && workflowToConfigureWa && (
          <WorkflowWhatsAppDialog
            open={configureWaDialogOpen}
            onClose={this.closeConfigureWhatsAppDialog}
            workflow={workflowToConfigureWa}
            orgId={this.orgId}
            fieldDef={this.fieldDef}
            templateVariables={this.templateVariables}
            onSaveSuccess={this.handleWhatsAppSaved}
            showToast={this.showToast}
          />
        )}

        {leadFunnelDialogOpen && (
          <LeadFunnelDialog
            open={leadFunnelDialogOpen}
            onClose={this.closeLeadFunnelDialog}
            orgId={this.orgId}
            showToast={this.showToast}
          />
        )}
      </>
    )
  }
}

const Styles = StyleSheet.create({
  toolbar: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    gap: 16,
    marginBottom: 16,
    '@media (max-width: 767px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 10,
    },
  },
  formControlContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5,
    flex: '0 0 200px',
    minWidth: 160,
    marginBottom: 8,
    '@media (max-width: 767px)': {
      width: '100%',
      flex: '1 1 auto',
      marginBottom: 0,
    },
  },
  label: {
    fontSize: 14,
    color: CommonTheme.subTextColor,
    margin: 0,
    display: 'inline-block',
  },
  formControlMainFilters: {
    width: '100%',
  },
  formControlFilters: {
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden',
  },
  textInputStyles: {
    padding: '11px 20px',
    flex: 1,
    textAlign: 'left',
    color: '#222222',
    fontSize: 16,
  },
  autoCompleteInputRoot: {
    paddingRight: 48,
  },
  formInputStyle: {
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
  textInput: {
    padding: '4px 0px',
  },
  searchBarContainer: {
    flex: 1,
    minWidth: 0,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    marginBottom: 4,
    gap: 4,
  },
  workflowKeyRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  mappedIcon: {
    fontSize: 24,
    color: '#9CA3AF',
  },
  titleLink: {
    textDecoration: 'none',
    color: AppTheme.primaryColor || '#122E79',
    ':hover': {
      textDecoration: 'underline',
    },
  },
  line1: {
    fontSize: 16,
    color: '#222222',
  },
  line3: {
    fontSize: 12,
    color: 'gray',
    textAlign: 'left',
  },
  cellName: {
    width: '30%',
  },
  cellOrder: {
    width: '10%',
  },
  cellWorkflow: {
    width: '30%',
  },
  workflowTitle: {
    display: 'block',
    fontWeight: 600,
    fontSize: 15,
    color: '#111827',
  },
  workflowKey: {
    display: 'block',
    fontSize: 12,
    color: '#6B7280',
    marginTop: 2,
  },
  chipsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    alignItems: 'center',
  },
  actionChip: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 11,
    height: 22,
    padding: '0 8px',
    borderRadius: 11,
    border: '1px solid #D1D5DB',
    backgroundColor: '#F9FAFB',
    color: '#374151',
    fontWeight: 500,
  },
  actionChipPrimary: {
    backgroundColor: '#EEF2FF',
    borderColor: '#C7D2FE',
    color: '#4338CA',
  },
  actionChipWarning: {
    backgroundColor: '#FFFBEB',
    borderColor: '#FCD34D',
    color: '#92400E',
  },
  actionChipWarningIcon: {
    fontSize: 12,
    marginRight: 4,
    color: '#D97706',
  },
  actionChipWaIcon: {
    fontSize: 14,
    marginRight: 4,
    color: '#25D366',
  },
  actionChipTooltipWrap: {
    display: 'inline-flex',
  },
  noActions: {
    fontSize: 12,
    fontStyle: 'italic',
    color: '#9CA3AF',
  },
  statusCell: {
    display: 'flex',
    alignItems: 'center',
  },
  cellWorkflow: {
    width: '30%',
  },
  cellEnabledFor: {
    width: '20%',
  },
  cellActions: {
    width: '32%',
  },
  cellStatus: {
    width: '18%',
  },
  tabsContainer: {
    width: '100%',
    borderBottom: '1px solid #E5E7EB',
    marginBottom: 16,
  },
  tabRoot: {
    minHeight: 44,
    textTransform: 'none',
    fontSize: 14,
    fontWeight: 500,
  },
  tabLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
  },
  tabCountBadge: {
    fontSize: 11,
    fontWeight: 600,
    padding: '1px 7px',
    borderRadius: 10,
    backgroundColor: '#E5E7EB',
    color: '#374151',
  },
  tabCountBadgeWarning: {
    fontSize: 11,
    fontWeight: 600,
    padding: '1px 7px',
    borderRadius: 10,
    backgroundColor: '#FDE68A',
    color: '#92400E',
  },
  legacyTableContainer: {
    border: '1px solid #E5E7EB',
    borderRadius: 8,
    overflow: 'hidden',
    backgroundColor: '#FFFFFF',
    width: '100%',
  },
  legacyTableCellHead: {
    backgroundColor: '#F9FAFB',
    fontWeight: 600,
    fontSize: 12,
    color: '#374151',
    padding: '12px 16px',
    borderBottom: '1px solid #E5E7EB',
  },
  legacyTableCell: {
    padding: '12px 16px',
    borderBottom: '1px solid #F3F4F6',
    verticalAlign: 'middle',
  },
  legacyTableRow: {
    ':hover': {
      backgroundColor: '#F9FAFB',
    },
  },
  cellLegacyName: {
    width: '28%',
  },
  cellLegacyRecipe: {
    width: '28%',
  },
  cellLegacyTeams: {
    width: '18%',
  },
  cellLegacyStatus: {
    width: '12%',
  },
  cellLegacyActions: {
    width: '14%',
  },
  legacyTitleWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    textAlign: 'left',
  },
  legacySubChip: {
    height: 20,
    fontSize: 10,
    backgroundColor: '#F3F4F6',
    color: '#4B5563',
  },
  legacyEntityChip: {
    height: 20,
    fontSize: 10,
    backgroundColor: '#EEF2FF',
    color: '#4338CA',
    border: '1px solid #C7D2FE',
  },
  legacyRecipeChip: {
    height: 22,
    fontSize: 11,
    backgroundColor: '#ECFDF5',
    color: '#047857',
    border: '1px solid #A7F3D0',
    fontWeight: 600,
  },
  legacyCustomChip: {
    height: 22,
    fontSize: 11,
    backgroundColor: '#F3F4F6',
    color: '#4B5563',
    border: '1px solid #E5E7EB',
  },
  legacyWaChip: {
    height: 22,
    fontSize: 11,
    backgroundColor: '#F0FDF4',
    color: '#15803D',
    border: '1px solid #BBF7D0',
  },
  legacyTriggerChip: {
    height: 20,
    fontSize: 10,
    backgroundColor: '#FFFBEB',
    color: '#B45309',
    border: '1px solid #FDE68A',
  },
  migrateIconButton: {
    border: '1px solid #D1D5DB',
    borderRadius: 6,
    padding: 6,
    color: AppTheme.primaryColor || '#122E79',
    backgroundColor: '#FFFFFF',
    ':hover': {
      backgroundColor: '#F3F4F6',
      borderColor: '#9CA3AF',
    },
  },
  mappedActionGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    alignItems: 'flex-start',
  },
  viewMigratedLink: {
    textDecoration: 'none',
  },
  viewMigratedButton: {
    textTransform: 'none',
    fontSize: 12,
    borderRadius: 6,
    padding: '2px 8px',
  },
  mappedText: {
    fontSize: 12,
    fontWeight: 500,
    color: '#059669',
  },
  emptyLegacyContainer: {
    padding: '48px 24px',
    textAlign: 'center',
    border: '1px solid #E5E7EB',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
})
